import { render, staticRenderFns } from "./PromotionList.vue?vue&type=template&id=8b4064f2"
import script from "./PromotionList.vue?vue&type=script&lang=js"
export * from "./PromotionList.vue?vue&type=script&lang=js"
import style0 from "./PromotionList.vue?vue&type=style&index=0&id=8b4064f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports